export default "__VITE_ASSET__OO1BqQ8P__"